import AppLoginLayout from './AppLoginLayout';

export default AppLoginLayout;
